<div
  class="price-profile-select flex justify-between items-center"
  [class]="class"
>
  <mot-slide-toggle
    [value]="showRoutePrice"
    (onToggleChange)="onToggleChange.emit($event)"
    [label]="priceCalculationLabel"
    class="text-sm"
  />
  <mot-select
    appearance="outline"
    [options]="tariffProfiles"
    class="!w-36 small"
    [textAlign]="'end'"
    [formControl]="priceProfileFormControl"
    [ariaLabel]="tariffProfileLabel"
  />
</div>
